import { render, staticRenderFns } from "./scanRegister.vue?vue&type=template&id=1497d72c&scoped=true&"
import script from "./scanRegister.vue?vue&type=script&lang=js&"
export * from "./scanRegister.vue?vue&type=script&lang=js&"
import style0 from "./scanRegister.vue?vue&type=style&index=0&id=1497d72c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497d72c",
  null
  
)

export default component.exports